import { Button } from "antd";
import styles from "./EmailDrawerFooter.module.scss";

type Props = {
  onClose: () => void;
  onSend: () => void;
  isSaving: boolean;
  isLastTab: boolean;
};

export const EmailDrawerFooter = ({
  onClose,
  onSend,
  isSaving,
  isLastTab,
}: Props) => {
  return (
    <div className={styles.footer}>
      <Button type="default" htmlType="button" onClick={onClose}>
        Cancel
      </Button>
      <Button
        type="primary"
        htmlType="button"
        onClick={onSend}
        loading={isSaving}
      >
        {isLastTab ? "Email" : "Next"}
      </Button>
    </div>
  );
};
